import { isPlatformServer } from '@angular/common';
import { DOCUMENT, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Rect } from '../../classes/rect.class';
import { AssetPageComponent } from '../../gallery-shared/pages/asset-page/asset-page.component';
import { enableBodyScroll } from '../../lib/toggle-body-scroll';
import { BrowserService } from '../../services/browser.service';
import { UpdateService } from '../../services/update.service';
import { AssetTransitionService } from '../services/asset-transition.service';

const getEl = (document: Document) => {
  const documentEl = document.querySelector('.asset-container.active .asset canvas:nth-child(1)');
  if (documentEl) return documentEl; // pdf
  return (
    document.querySelector('.asset-container.active .asset') ||
    document.querySelector('.asset-transitioner .asset-container')
  );
};

@Injectable({
  providedIn: 'root',
})
export class AssetPageDeactivation {
  private assetTransition = inject(AssetTransitionService);
  private browserService = inject(BrowserService);
  private updateService = inject(UpdateService);
  private document = inject<Document>(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  async canDeactivate(
    component: AssetPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Promise<boolean> {
    if (isPlatformServer(this.platformId)) return true;
    this.updateService.unsubscribeAsset(currentRoute.params.assetId);
    if (!currentRoute.params.assetId) return true;
    const asset = this.assetTransition.currentAsset;

    if (this.browserService.urlIsAssetUrl(nextState.url)) {
      return true;
    }
    enableBodyScroll('asset-page');
    if (!this.browserService.urlIsGalleryUrl(nextState.url)) return true; // Not going back to the gallery page
    const el = getEl(this.document);
    if (!el) {
      console.warn('Couldnt find .asset-container.active .asset');
      return true;
    }
    const bounds = el.getBoundingClientRect();
    const rect = Rect.fromDOMRect(bounds);
    await this.assetTransition.transitionFromAsset(asset, rect);
    return true;
  }
}
